module.exports = __webpack_public_path__ + "img/share-all.99a65422.svg";